<template>
  <v-input
    :name="schema.fullKey"
    :label="schema.label"
    :required="schema.required"
    :rules="schema.rules"
    :disabled="schema.disabled"
  >
    <v-tooltip v-if="schema.description" slot="append" left>
      <v-icon slot="activator">info</v-icon>
      <div class="vjsf-tooltip" v-html="schema.description" /> </v-tooltip
    >&nbsp;&nbsp;
    <v-menu
      :close-on-content-click="false"
      :close-on-click="true"
      direction="bottom"
      offset-y
    >
      <template slot="activator">
        <div
          :style="`background-color: ${inputValue};`"
          :class="
            inputValue
              ? 'color-picker-trigger'
              : 'color-picker-trigger color-picker-trigger-empty'
          "
        />
      </template>
      <!-- <color-picker
        :value="inputValue"
        :preset-colors="options.colors.swatches"
        @input="(val) => {inputValue = val.hex; input(); change()}"
      />-->
      <color-picker
        :value="inputValue"
        @input="
          (val) => {
            inputValue = val.hex
            input()
            change()
          }
        "
      />
    </v-menu>
  </v-input>
</template>

<script>
export default {
  name: 'RDColorPickerWidget',
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputValue: null
    }
  }
}
</script>

<style scoped></style>
